import React, { useEffect, useState } from "react";
import RegistrationStepLayout from "./RegistrationStepLayout";
import privacyIcon from "../../images/privacySettIcon.png";
import {
  getPrivacySettings,
  submitPrivacySettings,
} from "../../javaAxiosConfig";

import { PROFILE_UI_CONTENT } from "./profileContextContent";
import { resolveProfileUIText } from "./resolveProfileUIText";

import infoIcon from "../../images/i-buton.png";

import { useNavigate } from "react-router-dom";

/* =====================================================
   PRIVACY SETTING FLOW
===================================================== */

const PrivacySettingFlow = ({ onCompleted }) => {
  const profileCreatedById = Number(localStorage.getItem("profileCreatedById"));
  const gender = localStorage.getItem("selectedGender");

  const resolved = resolveProfileUIText({
    profileCreatedById,
    gender,
    stepKey: "PRIVACY",
    stepConfig: PROFILE_UI_CONTENT.PRIVACY,
  });

  return (
    <PrivacySettingStep
      title={resolved.title}
      subtitle={resolved.subtitle}
      onCompleted={onCompleted}
    />
  );
};

export default PrivacySettingFlow;

/* =====================================================
   STEP – PRIVACY SETTING
===================================================== */

const PrivacySettingStep = ({ onCompleted, title, subtitle }) => {
  const FIXED_PERCENT = 70;

  const [privacyData, setPrivacyData] = useState([]);
  const [activeModal, setActiveModal] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

const handleSkip = () => {
  console.log("⏭️ Privacy step skipped");

  localStorage.removeItem("register_current_step");
  localStorage.removeItem("register_registration_data");
  localStorage.removeItem("last_complete_step");

  navigate("/my_matches", { replace: true });
};

  /* ================= API ================= */

  useEffect(() => {
    fetchPrivacySettings();
  }, []);

  const fetchPrivacySettings = async () => {
    try {
      const res = await getPrivacySettings();
      setPrivacyData(res.data || []);
    } catch (err) {
      console.error("Privacy API Error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitPrivacy = async () => {
    try {
      await submitPrivacySettings(privacyData);

      // Move to matches
      onCompleted(); // this already navigates to /my_matches
    } catch (err) {
      console.error("Privacy submit failed", err);
      alert("Failed to save privacy settings. Please try again.");
    }
  };

  /* ================= HELPERS ================= */

  const formatText = (text) =>
    text
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/^\w/, (c) => c.toUpperCase());

  const getTitle = (type) => {
    if (type === "CONTACT") return "Who can contact me ?";
    if (type === "CHAT") return "Who can chat with me ?";
    if (type === "INTEREST") return "Who can send interest ?";
    return "";
  };

  const selectOption = (sIndex, oIndex) => {
    setPrivacyData((prev) =>
      prev.map((section, si) =>
        si !== sIndex
          ? section
          : {
              ...section,
              options: section.options.map((opt, oi) => ({
                ...opt,
                value: oi === oIndex,
              })),
            },
      ),
    );
  };

  const toggleStrictMatching = (sIndex, oIndex, mIndex) => {
    setPrivacyData((prev) =>
      prev.map((section, si) =>
        si !== sIndex
          ? section
          : {
              ...section,
              options: section.options.map((opt, oi) =>
                oi !== oIndex
                  ? opt
                  : {
                      ...opt,
                      strict_matching: opt.strict_matching.map((m, mi) =>
                        mi === mIndex ? { ...m, value: !m.value } : m,
                      ),
                    },
              ),
            },
      ),
    );
  };

  /* ================= RENDER ================= */

  if (loading) return null;

  return (
    <RegistrationStepLayout
  icon={privacyIcon}
  title={title}
  subtitle={subtitle}
  stepText="Step 1 of 1"
  onContinue={handleSubmitPrivacy}
  continueVariant="button"
  rightHeaderContent={
    <div
      onClick={handleSkip}
      style={{
        fontSize: 13,
        fontWeight: 600,
        color: "rgba(230,0,0,0.81)",
        cursor: "pointer",
        whiteSpace: "nowrap",
      }}
    >
      Skip
    </div>
  }
>
      {/* ===== SCROLLABLE PRIVACY SECTIONS ===== */}
      <div
        style={{
          width: "100%",
          marginTop: 20,
          height: "360px", // ✅ forces scroll
          overflowY: "auto",
          paddingRight: 6,
        }}
      >
        {privacyData.map((section, sIndex) => (
          <div key={section.type} style={{ marginBottom: 28 }}>
            {/* TITLE */}
            <div style={sectionTitle}>{getTitle(section.type)}</div>

            {/* OPTIONS */}
            {section.options.map((option, oIndex) => {
              const active = option.value;

              return (
                <div
                  key={option.name}
                  onClick={() => {
                    selectOption(sIndex, oIndex);

                    if (
                      option.name === "MATCHING_CRITERIA" &&
                      option.strict_matching
                    ) {
                      setActiveModal({ sIndex, oIndex });
                    }
                  }}
                  style={{
                    ...optionBox,
                    ...(active ? optionActive : {}),
                  }}
                >
                  <span>{formatText(option.name)}</span>

                  {option.strict_matching && (
                    <span style={percentBadge}>{FIXED_PERCENT}%</span>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* ===== INFO (FIXED) ===== */}

      <div
        style={{
          ...infoBox,
          display: "flex",
          alignItems: "flex-start",
          gap: 10,
          textAlign: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={infoIcon}
          alt="info"
          style={{
            width: 20,
            height: 20,
            flexShrink: 0,
            marginTop: 0,
          }}
        />

        <span style={{ lineHeight: "1.98" }}>
          You can update these criteria anytime.
        </span>
      </div>

      {/* <div style={infoBox}>
        You can update these criteria anytime.
      </div> */}

      {/* ===== MODAL ===== */}
      {activeModal && (
        <div style={overlay}>
          <div style={modal}>
            <div style={closeBtn} onClick={() => setActiveModal(null)}>
  <span
    style={{
      fontSize: 16,
      fontWeight: 700,
      color: "#000",
      lineHeight: 1,
    }}
  >
    ✕
  </span>
</div>

            <div style={modalHeader}>
              <div style={{ fontSize: 16, fontWeight: 700 }}>
                Preference
              </div>
              <div style={percentCircle}>{FIXED_PERCENT}%</div>
            </div>

            {privacyData[activeModal.sIndex].options[
              activeModal.oIndex
            ].strict_matching.map((item, i) => (
              <React.Fragment key={item.name}>
                <div style={row}>
                  <span style={{ fontWeight: 600 }}>
                    {formatText(item.name)}
                  </span>

                  <div
                    onClick={() =>
                      toggleStrictMatching(
                        activeModal.sIndex,
                        activeModal.oIndex,
                        i,
                      )
                    }
                    style={{
                      ...switchBox,
                      ...(item.value ? switchOn : {}),
                    }}
                  >
                    <div
                      style={{
                        ...switchKnob,
                        ...(item.value ? knobOn : {}),
                      }}
                    />
                  </div>
                </div>

                {i !==
                  privacyData[activeModal.sIndex].options[activeModal.oIndex]
                    .strict_matching.length -
                    1 && <div style={divider} />}
              </React.Fragment>
            ))}

            <div style={saveBtn} onClick={() => setActiveModal(null)}>
              Save Preferences
            </div>

            {/* <div style={modalInfo}>
              You can update these criteria anytime.
            </div> */}

            <div
              style={{
                ...modalInfo,
                display: "flex",
                alignItems: "flex-start",
                gap: 10,
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={infoIcon}
                alt="info"
                style={{
                  width: 18,
                  height: 18,
                  flexShrink: 0,
                  marginTop: 0,
                }}
              />

              <span style={{ lineHeight: "1.59" }}>
                You can update these criteria anytime.
              </span>
            </div>
          </div>
        </div>
      )}
    </RegistrationStepLayout>
  );
};

/* =====================================================
   STYLES (UNCHANGED)
===================================================== */

const sectionTitle = {
  fontSize: 16,
  fontWeight: 700,
  marginBottom: 12,
};

const optionBox = {
  height: 54,
  borderRadius: 30,
  border: "1.5px solid #E6E6E6",
  padding: "0 16px",
  marginBottom: 10,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  cursor: "pointer",
  fontWeight: 600,
};

const optionActive = {
  borderColor: "rgba(230,0,0,0.81)",
  background: "#FFF1F1",
  color: "rgba(230,0,0,0.81)",
};

const percentBadge = {
  background: "#ffffff",
  color: "rgba(230,0,0,0.81)",
  padding: "4px 10px",
  fontSize: 12,
  borderRadius: 20,
};

const infoBox = {
  marginTop: 20,
  width: "100%",
  padding: 14,
  border: "1px dashed rgba(230,0,0,0.5)",
  borderRadius: 12,
  fontSize: 12,
  color: "#555",
  textAlign: "center",
};

/* ===== MODAL ===== */

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 999,
};

const modal = {
  background: "#fff",
  width: "90%",
  maxWidth: 420,
  borderRadius: 20,
  padding: 30,
  position: "relative",
};


const closeBtn = {
  position: "absolute",
  top: 14,
  right: 14,
  width: 35,
  height: 35,
  borderRadius: "50%",
  backgroundColor: "#fff",
  border: "1px solid #fff0ed",
  boxShadow: "0px 4px 4px #fff0ed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxSizing: "border-box",
};

const modalHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingRight: 40,
};

const percentCircle = {
  width: 46,
  height: 46,
  borderRadius: "50%",
  background: "#FFF1F1",
  border: "1px solid #FFDCDC",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  color: "rgba(230,0,0,0.81)",
};

const row = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "14px 0",
};

const divider = {
  height: 1,
  background: "#E0E0E0",
};

const switchBox = {
  width: 38,
  height: 20,
  borderRadius: 20,
  background: "#CCC",
  position: "relative",
  cursor: "pointer",
};

const switchOn = {
  background: "rgba(230,0,0,0.81)",
};

const switchKnob = {
  width: 16,
  height: 16,
  background: "#FFF",
  borderRadius: "50%",
  position: "absolute",
  top: 2,
  left: 2,
  transition: "0.2s",
};

const knobOn = {
  left: 20,
};

const saveBtn = {
  marginTop: 16,
  background:
    "linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(180deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81))",
  color: "#fff",
  textAlign: "center",
  padding: 12,
  borderRadius: 10,
  fontWeight: 700,
  cursor: "pointer",
};

const modalInfo = {
  marginTop: 12,
  fontSize: 12,
  color: "#666",
  textAlign: "center",
  width: "100%",
  padding: 10,
  border: "1px dashed rgba(230,0,0,0.5)",
  borderRadius: 12,
  fontSize: 12,
};
